import React from 'react';
import Dashboard from '../components/Dashboard';
import DashboardIcon from '@material-ui/icons/Dashboard';
import SignalIcon from '@material-ui/icons/SignalWifi1BarLock';
import AssignmentIcon from '@material-ui/icons/Assignment';
import RouterIcon from '@material-ui/icons/Router';
import TuneIcon from '@material-ui/icons/Tune';
import ListIcon from '@material-ui/icons/List';
import TimelineIcon from '@material-ui/icons/Timeline';
import EventIcon from '@material-ui/icons/Event';
import PlayIcon from '@material-ui/icons/PlayArrow';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import AppartmentIcon from '@material-ui/icons/Apartment';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import PlaceIcon from '@material-ui/icons/PlaceOutlined';
import PeopleIcon from '@material-ui/icons/People';
import SubjectIcon from '@material-ui/icons/Subject';
import AnnouncementIcon from '@material-ui/icons/Announcement';

import Alerts from "../components/Alerts";
import PairingModes from "../components/PairingModes";
import Pairings from "../components/Pairings";
import Devices from "../components/Devices";
import Configurations from "../components/Configurations";
import Journals from "../components/Journals";
import Measurements from "../components/Measurements";
import Events from "../components/Events";
import Commands from "../components/Commands";
import Leases from "../components/Leases";
import Syncs from "../components/Syncs";
import Tenants from "../components/Tenants";
import Buildings from "../components/Buildings";
import Parcels from "../components/Parcels";
import Taps from "../components/Taps";
import Users from "../components/Users";
import DeviceStatusReport from "./DevicesStatusReport";
import DeviceFindingsReport from "./DevicesFindingsReport";
import DevicesFindings from './DevicesFindings'
import IconWithBadge from '../components/IconWithBadge';
import SignalWifi3BarIcon from '@material-ui/icons/SignalWifi3Bar';
import FavoriteIcon from '@material-ui/icons/Favorite';

import { ROLE_ADMIN, ROLE_ASSISTANT, ROLE_OWNER, ROLE_EDITOR, ROLE_READER } from "../common/iam"


import * as i18n from "../common/i18n";
import LateDevices from './LateDevices';

export const menus = [
    {
        entries: [
            {
                primary: i18n.get("menus.dashboard"),
                icon: <DashboardIcon />,
                component: <Dashboard />
            }],
        roles: [ROLE_ADMIN, ROLE_OWNER, ROLE_EDITOR, ROLE_ASSISTANT, ROLE_READER]

    },
    {
        title: i18n.get("menus.deviceManagement"),
        entries: [
            {
                primary: i18n.get("menus.alerts"),
                component: <Alerts />,
                icon: (
                    <IconWithBadge
                      icon={<AnnouncementIcon />}
                      selector={(data) => {
                        return data.alertCount;
                      }}
                    />
                  ),
                // icon: <AnnouncementIcon />,
            },
            {
                primary: i18n.get("menus.pairingModes"),
                component: <PairingModes />,
                icon: <SignalIcon />,
            },
            {
                primary: i18n.get("menus.pairings"),
                component: <Pairings />,
                icon: <SignalWifi3BarIcon />,
            },
            {
                primary: i18n.get("menus.devices"),
                component: <Devices/>,
                icon: <RouterIcon />,
            },
            {
                primary: i18n.get("menus.lateDevices"),
                component: <LateDevices/>,
                icon: <SubjectIcon />
            },
            {
                primary: i18n.get("menus.configurations"),
                component: <Configurations/>,
                icon: <TuneIcon />,
            },
            {
                primary: i18n.get("menus.journals"),
                component: <Journals/>,
                icon: <ListIcon />,
            },
            {
                primary: i18n.get("menus.measurements"),
                component: <Measurements/>,
                icon: <TimelineIcon />,
            },
            {
                primary: i18n.get("menus.qualityDevices"),
                component: <DevicesFindings/>,
                icon: <SubjectIcon />
            },
            {
                primary: i18n.get("menus.events"),
                component: <Events/>,
                icon: <EventIcon />,
            },
            {
                primary: i18n.get("menus.syncs"),
                component: <Syncs/>,
                icon: <FavoriteIcon />,
            },
            {
                primary: i18n.get("menus.commands"),
                component: <Commands/>,
                icon: <PlayIcon />,
            }
        ],
        roles: [ROLE_ADMIN, ROLE_OWNER, ROLE_EDITOR, ROLE_ASSISTANT, ROLE_READER]

    },
    {
        title: i18n.get("menus.reports"),
        entries: [
            {
                primary: i18n.get("menus.deviceStatus"),
                component: <DeviceStatusReport />,
                icon: <RouterIcon />,
            },
            {
                primary: i18n.get("menus.deviceFindings"),
                component: <DeviceFindingsReport />,
                icon: <SubjectIcon />,
            },
        ],
        roles: [ROLE_ADMIN, ROLE_OWNER, ROLE_EDITOR, ROLE_ASSISTANT, ROLE_READER]

    },
    {
        title: i18n.get("menus.tenantManagement"),
        entries: [
            {
                primary: i18n.get("menus.leases"),
                component: <Leases/>,
                icon: <AssignmentIcon />
            },
            {
                primary: i18n.get("menus.tenants"),
                component: <Tenants/>,
                icon: <ContactMailIcon />
            },
            {
                primary: i18n.get("menus.buildings"),
                component: <Buildings/>,
                icon: <AppartmentIcon />
            },
            {
                primary: i18n.get("menus.parcels"),
                component: <Parcels/>,
                icon: <MeetingRoomIcon />
            },
            {
                primary: i18n.get("menus.taps"),
                component: <Taps/>,
                icon: <PlaceIcon />
            }
        ],
        roles: [ROLE_ADMIN, ROLE_OWNER, ROLE_EDITOR, ROLE_READER]

    },
    {
        title: i18n.get("menus.organization"),
        entries: [
            {
                primary: i18n.get("menus.user"),
                component: <Users/>,
                icon: <PeopleIcon />
            }],
        roles: [ROLE_ADMIN]
    },
];